export const SET_STATS = 'SET_STATS';
